export default "__VITE_ASSET__CjZZklvB__"